import React from "react";
import LevelUp from "./LevelUp";

const WhatsNext = ({ type }) => <LevelUp type={type} submittedToReview={true} />;
export default WhatsNext;
